import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import combosActionTypes from '../../constants/actions/combos/combos'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getPaymentMethodCampaign from '../../services/paymentMethodCampaign/getPaymentMethod'

export function * fetchPaymentMethodCampaign ({ includeDeletes }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const paymentMethodCampaignCombo = yield call(getPaymentMethodCampaign, auth.token, includeDeletes)
    yield put(fetchCombosSuccess({ paymentMethodCampaignCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchPaymentMethodCampaign () {
  yield takeLatest(combosActionTypes.FETCH_PAYMENT_METHOD_CAMPAIGN, fetchPaymentMethodCampaign)
}
